
{
  "familyId": "GET-PROC-TOENAME",
  "questions": [
    {
      "id": "GET-PROC-TOENAME-001",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verkoopt een fiets voor €425. De prijs stijgt met 17%. Wat is de nieuwe prijs?",
      "options": [
        "€497,25",
        "€442",
        "€352,75",
        "€637,50"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 17,
            "label": "17% toename op €425 → €72,25 erbij, €497,25 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 17% prijstoename" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Niet-ronde toename — 1%-methode",
            "content": "1% van €425 = €4,25. Dan 17% = 17 × €4,25 = €72,25 toename. Nieuwe prijs: €425 + €72,25 = €497,25. Of direct: €425 × 1,17 = €497,25.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_prijs",
      "variantIndex": 1,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.toename-als-vast-bedrag", "label": "17 i.p.v. 17% opgeteld", "optionIndex": 1 },
          { "id": "proc.toename-als-afname", "label": "Toename als afname gerekend", "optionIndex": 2 },
          { "id": "proc.toename-factor-fout", "label": "Factor 1,5 i.p.v. 1,17", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij 17% (niet-rond percentage) moet je exact rekenen. 1% van €425 = €4,25. Dan 17% = 17 × €4,25 = €72,25 toename. Nieuwe prijs: €425 + €72,25 = €497,25. Of direct: €425 × 1,17 = €497,25. Tegenproef: €497,25 ÷ €425 = 1,17 ✓.",
        "solutionSteps": [
          "1% van €425 = €4,25",
          "17% = 17 × €4,25 = €72,25",
          "Nieuwe prijs: €425 + €72,25 = €497,25",
          "Of direct: €425 × 1,17 = €497,25"
        ],
        "distractorExplanations": {
          "0": "Goed! 1% = €4,25, dus 17% = €72,25. €425 + €72,25 = €497,25.",
          "1": "Je hebt waarschijnlijk €17 opgeteld in plaats van 17%. Maar 17% van €425 = €72,25, niet €17. Onthoud: procent berekenen vóór optellen.",
          "2": "Je hebt waarschijnlijk afgetrokken in plaats van opgeteld. Bij een stijging telt de toename erbij: €425 + €72,25 = €497,25, niet €425 − €72,25 = €352,75.",
          "3": "Je hebt waarschijnlijk factor 1,5 gebruikt: €425 × 1,5 = €637,50. Maar 17% = 0,17, dus de factor is 1,17, niet 1,5."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-002",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een stadsplanner meldt dat een stad met 62.500 inwoners 12% is gegroeid. Hoeveel inwoners zijn er nu?",
      "options": [
        "70.000",
        "62.512",
        "55.000",
        "75.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 12,
            "label": "12% groei op 62.500 → 7.500 erbij, 70.000 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 12% bevolkingsgroei" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bevolkingsgroei met niet-rond %",
            "content": "1% van 62.500 = 625. Dan 12% = 12 × 625 = 7.500 inwoners erbij. Nieuwe stand: 62.500 + 7.500 = 70.000. Of direct: 62.500 × 1,12 = 70.000.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_bevolking",
      "variantIndex": 2,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.toename-als-vast-bedrag", "label": "12 i.p.v. 12% opgeteld", "optionIndex": 1 },
          { "id": "proc.toename-als-afname", "label": "Groei als daling gerekend", "optionIndex": 2 },
          { "id": "proc.toename-percentage-verwisseld", "label": "20% i.p.v. 12% gebruikt", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "1% van 62.500 = 625 inwoners. Dan 12% = 12 × 625 = 7.500 inwoners erbij. Nieuwe stand: 62.500 + 7.500 = 70.000. Of direct: 62.500 × 1,12 = 70.000. Tegenproef: 70.000 ÷ 62.500 = 1,12 ✓.",
        "solutionSteps": [
          "1% van 62.500 = 625 inwoners",
          "12% = 12 × 625 = 7.500",
          "Nieuwe stand: 62.500 + 7.500 = 70.000",
          "Of direct: 62.500 × 1,12 = 70.000"
        ],
        "distractorExplanations": {
          "0": "Goed! 1% = 625, dus 12% = 7.500 inwoners erbij. Totaal: 70.000.",
          "1": "Je hebt waarschijnlijk gewoon 12 inwoners opgeteld i.p.v. 12%. 12% van 62.500 = 7.500, niet 12. Onthoud: eerst het percentage berekenen.",
          "2": "Je hebt waarschijnlijk de groei afgetrokken in plaats van opgeteld. Bij groei tel je op: 62.500 + 7.500 = 70.000, niet 62.500 − 7.500 = 55.000.",
          "3": "Je hebt waarschijnlijk 20% gerekend i.p.v. 12%: 20% × 62.500 = 12.500 → 75.000. Lees het percentage exact: 12%, niet 20%."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-003",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een econoom berekent de groeifactor. Met welke factor vermenigvuldig je bij een toename van 25%?",
      "options": [
        "1,25",
        "0,25",
        "1,025",
        "25"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 25,
            "label": "25% toename → groeifactor 1 + 0,25 = 1,25",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 25% groei, factor 1,25" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Groeifactor 1,25 = 125%",
            "content": "Origineel = 100%. Toename = 25%. Samen: 100% + 25% = 125%, oftewel factor 1,25.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_factor",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.toename-percentage-verwisseld", "label": "Gebruikt percentage als factor i.p.v. (1 + percentage)", "optionIndex": 1 },
          { "id": "rek.rekenfout", "label": "Decimaal-conversiefout (25% = 0,025)", "optionIndex": 2 },
          { "id": "proc.toename-als-vast-bedrag", "label": "Percentage als rauw getal als factor gebruikt", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De groeifactor bereken je door het percentage als decimaal op te tellen bij 1. Bij 25% toename: 25% = 0,25. Factor = 1 + 0,25 = 1,25. Met deze factor vermenigvuldig je het oorspronkelijke bedrag om de nieuwe waarde te krijgen.",
        "solutionSteps": [
          "Zet het percentage om naar een decimaal: 25% = 0,25",
          "Tel op bij 1: factor = 1 + 0,25 = 1,25",
          "Check: 1,25 = 125% → 25% meer dan het origineel ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Toename van 25% → factor = 1 + 0,25 = 1,25.",
          "1": "Je dacht waarschijnlijk dat het percentage zelf de factor is. Maar 0,25 is alleen de toename, niet de factor. Onthoud: factor = 1 + 0,25 = 1,25 (je houdt het oorspronkelijke bedrag erbij).",
          "2": "Je dacht waarschijnlijk dat 25% = 0,025. Maar 25% = 0,25 (deel door 100, niet door 1000). Onthoud: 2,5% = 0,025, maar 25% = 0,25.",
          "3": "Je dacht waarschijnlijk dat het percentage zelf als factor werkt. Maar 25 is geen bruikbare factor — je moet het eerst omzetten naar een decimaal. Onthoud: 25% = 0,25, factor = 1,25."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-004",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een bankmedewerker berekent de rente. Een spaarrekening van €2.000 groeit met 3,5% rente. Hoeveel staat er na één jaar?",
      "options": [
        "€2.070",
        "€2.035",
        "€2.700",
        "€2.350"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 3.5,
            "label": "3,5% rente op €2.000 → €70 erbij, €2.070 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 3,5% rente" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rente uitgesplitst",
            "content": "Inleg (100%): €2.000. Rente (3,5%): €70. Eindsaldo: €2.000 + €70 = €2.070.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_rente",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.toename-als-vast-bedrag", "label": "€35 opgeteld i.p.v. 3,5% berekend", "optionIndex": 1 },
          { "id": "proc.toename-percentage-verwisseld", "label": "3,5% verwisseld met 35%", "optionIndex": 2 },
          { "id": "proc.toename-factor-fout", "label": "Factor 1,35 i.p.v. 1,035 gebruikt", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Je berekent de rente: 3,5% van €2.000 = 0,035 × 2.000 = €70. Het nieuwe saldo: €2.000 + €70 = €2.070. Let op de komma in het percentage: 3,5% = 0,035, niet 0,35.",
        "solutionSteps": [
          "Zet het percentage om: 3,5% = 0,035",
          "Bereken de rente: 0,035 × €2.000 = €70",
          "Tel op: €2.000 + €70 = €2.070"
        ],
        "distractorExplanations": {
          "0": "Goed! 3,5% van 2.000 = 70. Na één jaar: 2.000 + 70 = €2.070.",
          "1": "Je dacht waarschijnlijk dat je 35 optelt. Maar 3,5% van 2.000 = 70, niet 35. Onthoud: 3,5% = 0,035, en 0,035 × 2.000 = 70.",
          "2": "Je dacht waarschijnlijk dat 3,5% = 35%. Maar 35% van 2.000 = 700, terwijl 3,5% van 2.000 = 70. Onthoud: let goed op de komma in het percentage.",
          "3": "Je dacht waarschijnlijk dat de factor 1,35 is. Maar 3,5% = 0,035, dus de factor = 1,035, niet 1,35. Onthoud: 2.000 × 1,035 = 2.070, niet 2.000 × 1,35 = 2.350."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-005",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "fill_in",
      "question": "Een horecaondernemer verhoogt de menuprijs van €18,50 met 24%. Wat is de nieuwe prijs in euro's?",
      "correctAnswer": "22,94",
      "data": {
        "acceptedAnswers": ["22,94", "22.94", "€22,94", "€ 22,94", "€22.94"],
        "placeholder": "€ ...",
        "inputType": "number"
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 24,
            "label": "24% prijsverhoging op €18,50 → €4,44 erbij, €22,94 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 24% prijsverhoging" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Niet-ronde % op niet-rond bedrag",
            "content": "1% van €18,50 = €0,185. Dan 24% = 24 × €0,185 = €4,44 (afgerond op cent). Nieuwe prijs: €18,50 + €4,44 = €22,94. Of direct: €18,50 × 1,24 = €22,94.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_menuprijs",
      "variantIndex": 5,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "1% van €18,50 = €0,185. Dan 24% = 24 × €0,185 = €4,44 (op cent afgerond). Nieuwe prijs: €18,50 + €4,44 = €22,94. Of direct: €18,50 × 1,24 = €22,94. Tegenproef: €22,94 ÷ €18,50 ≈ 1,24 ✓. Let op: bij geldbedragen rond je af op cent (2 decimalen).",
        "solutionSteps": [
          "1% van €18,50 = €0,185",
          "24% = 24 × €0,185 = €4,44",
          "Nieuwe prijs: €18,50 + €4,44 = €22,94",
          "Of direct: €18,50 × 1,24 = €22,94"
        ]
      }
    },
    {
      "id": "GET-PROC-TOENAME-006",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "comparison_judge",
      "question": "Twee winkels passen een prijsverhoging toe op een artikel van €200. Winkel A verhoogt met 20%. Winkel B verhoogt eerst met 10% en daarna nog eens met 10%. Welke aanpak geeft de hoogste eindprijs?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "B", "content": "Winkel B: €200 × 1,10 × 1,10 = €242 (10% boven 10% van een nieuwe basis)" },
            { "id": "A", "content": "Winkel A: €200 × 1,20 = €240 (eenmalig 20% toename)" },
            { "id": "gelijk", "content": "Beide winkels: €240 (10% + 10% = 20%)" }
          ],
          "criterion": "Welke berekening geeft de hoogste eindprijs?",
          "correctIndex": 0
        }
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 20,
            "label": "Vergelijk: één keer 20% vs. twee keer 10%",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: vergelijking van procentuele toenames" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee keer 10% — de tweede 10% rekent over de nieuwe waarde",
            "content": "Stap 1 (100%): €200. +10% van €200 = €20 → €220. +10% van €220 = €22 → €242. De tweede 10% telt over een nieuwe basis, dus uitkomst is hoger dan eenmalig 20%.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_samengesteld_vergelijk",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.percent-compound-added", "label": "Telt percentages op alsof ze additief zijn", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Twee keer 10% is niet hetzelfde als één keer 20%. Bij de tweede verhoging reken je over de nieuwe waarde (€220), dus krijg je €22 erbij in plaats van €20. Resultaat: €200 × 1,10 × 1,10 = €242. Winkel A: €200 × 1,20 = €240. Verschil: €2. Procenten zijn niet additief — dit heet samengestelde groei.",
        "solutionSteps": [
          "Winkel A: €200 × 1,20 = €240",
          "Winkel B stap 1: €200 + 10% = €220",
          "Winkel B stap 2: €220 + 10% van 220 = €220 + €22 = €242",
          "Vergelijk: €242 > €240 → Winkel B is duurder"
        ]
      }
    }
  ]
}
